// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --console-bg: #f4f6fb;
  --console-surface: #ffffff;
  --console-surface-muted: #f8fafc;
  --console-border: #d8e0ea;
  --console-border-strong: #c7d1dd;
  --console-text: #132238;
  --console-text-soft: #5c6b80;
  --console-text-faint: #7c8ba1;
  --console-accent: #d92d43;
  --console-accent-strong: #b61f33;
  --console-accent-soft: #fff1f3;
  --console-success: #0b7a54;
  --console-success-soft: #e8f8f1;
  --console-warning-soft: #fff7e8;
  --console-danger-soft: #fff0f2;
  --console-shadow: 0 18px 48px rgba(15, 23, 42, 0.08);
  --console-shadow-soft: 0 10px 24px rgba(15, 23, 42, 0.06);
  --console-radius-lg: 24px;
  --console-radius-md: 16px;
  --console-radius-sm: 12px;
  --console-open-sidebar-width: 288px;
  --console-collapsed-sidebar-width: 92px;
}

html,
body.content-console-body {
  width: 100%;
  min-height: 100%;
  height: 100%;
}

body.content-console-body {
  overflow: hidden;
  background: var(--console-bg);
}

#root.content-console-root {
  width: 100vw;
  max-width: none;
  min-width: 100vw;
  min-height: 100dvh;
  height: 100dvh;
  margin: 0;
  border: 0;
  display: block;
  text-align: left;
}

.content-console-page {
  position: fixed;
  inset: 0;
  min-height: 100dvh;
  background: var(--console-bg);
  color: var(--console-text);
}

.content-console-app-shell {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.content-console-app-sidebar {
  position: absolute;
  inset: 0 auto 0 0;
  width: var(--console-open-sidebar-width);
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 14px 14px;
  background: var(--console-surface);
  border-right: 1px solid var(--console-border);
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 40;
  transition:
    width 220ms ease,
    transform 220ms ease;
}

.content-console-main-shell {
  position: absolute;
  inset: 0 0 0 var(--console-open-sidebar-width);
  overflow: auto;
  padding: 32px;
  box-sizing: border-box;
  transition: inset 220ms ease;
}

.content-console-page.is-sidebar-collapsed .content-console-app-sidebar {
  width: var(--console-collapsed-sidebar-width);
  padding-inline: 12px;
}

.content-console-page.is-sidebar-collapsed .content-console-main-shell {
  inset: 0 0 0 var(--console-collapsed-sidebar-width);
}

.content-console-mobile-toggle,
.content-console-mobile-backdrop {
  display: none;
}

.content-console-sidebar-topbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.content-console-sidebar-brand {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.content-console-brand-logo {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  object-fit: contain;
  flex-shrink: 0;
  background: #fff;
  border: 1px solid var(--console-border);
  box-shadow: var(--console-shadow-soft);
}

.content-console-sidebar-brand-copy {
  min-width: 0;
}

.content-console-sidebar-brand-copy h1 {
  margin: 0;
  font-size: 15px;
  line-height: 1.2;
  color: var(--console-text);
}

.content-console-sidebar-topbar-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.content-console-sidebar-icon-button,
.content-console-mobile-toggle {
  width: 44px;
  height: 44px;
  border: 1px solid var(--console-border-strong);
  border-radius: 14px;
  background: var(--console-surface);
  color: var(--console-text-soft);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background-color 160ms ease,
    border-color 160ms ease,
    color 160ms ease,
    box-shadow 160ms ease;
}

.content-console-sidebar-icon-button:hover,
.content-console-mobile-toggle:hover {
  border-color: #b6c3d4;
  color: var(--console-text);
  box-shadow: var(--console-shadow-soft);
}

.content-console-sidebar-icon-button svg {
  width: 18px;
  height: 18px;
}

.content-console-sidebar-icon-button.is-mobile-only {
  display: none;
}

.content-console-sidebar-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 0;
}

.content-console-sidebar-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--console-text-faint);
}

.content-console-sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.content-console-sidebar-nav-item {
  width: 100%;
  border: 1px solid transparent;
  border-radius: 14px;
  background: transparent;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  text-align: left;
  transition:
    background-color 160ms ease,
    border-color 160ms ease,
    box-shadow 160ms ease,
    transform 160ms ease;
}

.content-console-sidebar-nav-item:hover:not(:disabled) {
  background: #fff8f8;
  border-color: #f2d4d9;
}

.content-console-sidebar-nav-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.content-console-sidebar-nav-item.is-active {
  background: #fff6f7;
  border-color: #f0c6ce;
  box-shadow: 0 10px 24px rgba(217, 45, 67, 0.08);
}

.content-console-sidebar-nav-rail {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #f3b6bf;
  color: #ffffff;
  transition: background-color 160ms ease, transform 160ms ease;
}

.content-console-sidebar-nav-item.is-active .content-console-sidebar-nav-rail {
  background: var(--console-accent);
}

.content-console-sidebar-nav-item:hover .content-console-sidebar-nav-rail {
  background: var(--console-accent-strong);
}

.content-console-sidebar-nav-rail svg {
  width: 18px;
  height: 18px;
}

.content-console-sidebar-nav-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.content-console-sidebar-nav-copy strong {
  font-size: 15px;
  line-height: 1.2;
  color: var(--console-text);
}

.content-console-sidebar-nav-copy span {
  font-size: 13px;
  line-height: 1.45;
  color: var(--console-text-soft);
}

.content-console-sidebar-user-card {
  padding: 14px;
  border: 1px solid var(--console-border);
  border-radius: 16px;
  background: var(--console-surface-muted);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.content-console-sidebar-user-card strong {
  display: block;
  margin-bottom: 4px;
  font-size: 16px;
  color: var(--console-text);
}

.content-console-sidebar-user-card span {
  color: var(--console-text-soft);
}

.content-console-sidebar-role {
  align-self: flex-start;
  padding: 6px 10px;
  border-radius: 999px;
  background: #eef2f7;
  color: var(--console-text-soft);
  font-size: 13px;
  font-weight: 700;
}

.content-console-sidebar-role.is-super {
  background: var(--console-accent-soft);
  color: var(--console-accent-strong);
}

.content-console-sidebar-permissions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.content-console-mini-tag {
  padding: 6px 10px;
  border-radius: 999px;
  background: #eef2f7;
  color: var(--console-text-soft);
  font-size: 13px;
  font-weight: 700;
}

.content-console-mini-tag.is-enabled {
  background: var(--console-accent-soft);
  color: var(--console-accent-strong);
}

.content-console-sidebar-footer {
  margin-top: 6px;
}

.content-console-page.is-sidebar-collapsed .content-console-sidebar-brand-copy,
.content-console-page.is-sidebar-collapsed .content-console-sidebar-label,
.content-console-page.is-sidebar-collapsed .content-console-sidebar-user-card,
.content-console-page.is-sidebar-collapsed .content-console-sidebar-permissions,
.content-console-page.is-sidebar-collapsed .content-console-sidebar-footer {
  display: none;
}

.content-console-page.is-sidebar-collapsed .content-console-app-sidebar .content-console-sidebar-section:not(:first-of-type) {
  display: none;
}

.content-console-page.is-sidebar-collapsed .content-console-sidebar-topbar {
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.content-console-page.is-sidebar-collapsed .content-console-sidebar-brand {
  justify-content: center;
}

.content-console-page.is-sidebar-collapsed .content-console-sidebar-nav-item {
  justify-content: center;
  padding: 10px;
}

.content-console-page.is-sidebar-collapsed .content-console-sidebar-nav-copy {
  display: none;
}

.content-console-page.is-sidebar-collapsed .content-console-sidebar-section {
  align-items: center;
}

.content-console-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 18px;
  padding: 0;
}

.content-console-page-header-copy {
  max-width: 720px;
}

.content-console-kicker {
  display: inline-block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--console-accent);
}

.content-console-page-header-copy h2 {
  margin: 0;
  font-size: 28px;
  line-height: 1.15;
  color: var(--console-text);
}

.content-console-page-header-copy p {
  margin-top: 8px;
  max-width: 680px;
  color: var(--console-text-soft);
  line-height: 1.65;
}

.content-console-page-header-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  gap: 8px;
  min-width: min(420px, 100%);
}

.content-console-page-header-stat,
.content-console-summary-card,
.content-console-section-card,
.content-console-sidebar,
.content-console-editor,
.content-console-note-card {
  background: var(--console-surface);
  border: 1px solid var(--console-border);
  box-shadow: var(--console-shadow-soft);
}

.content-console-page-header-stat {
  padding: 12px 14px;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 2px;
}

.content-console-page-header-stat span {
  font-size: 13px;
  color: var(--console-text-faint);
  line-height: 1.3;
}

.content-console-page-header-stat strong {
  font-size: 15px;
  line-height: 1.2;
  color: var(--console-text);
}

.content-console-summary-grid {
  display: grid;
  gap: 12px;
  margin-bottom: 14px;
  align-items: start;
  padding: 0;
}

.content-console-summary-grid.is-three-column {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.content-console-summary-card {
  padding: 12px 16px;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 2px;
}

.content-console-summary-card span {
  display: block;
  margin: 0;
  font-size: 13px;
  color: var(--console-text-faint);
  line-height: 1.25;
}

.content-console-summary-card strong {
  display: block;
  margin: 0;
  font-size: 30px;
  line-height: 1;
  color: var(--console-text);
}

.content-console-summary-card p {
  margin: 0;
  font-size: 14px;
  line-height: 1.35;
  color: var(--console-text-soft);
}

.content-console-feedback {
  margin-bottom: 24px;
  padding: 14px 16px;
  border-radius: 16px;
  border: 1px solid #c8d5e3;
  background: #edf5ff;
  color: #0f3a67;
}

.content-console-feedback.is-error {
  border-color: #efc1cb;
  background: #fff1f3;
  color: #8a2332;
}

.content-console-feedback.is-success {
  border-color: #bde6d6;
  background: #effcf6;
  color: #096344;
}

.content-console-layout,
.content-console-account-shell {
  display: grid;
  gap: 24px;
}

.content-console-layout {
  grid-template-columns: 340px minmax(0, 1fr);
  align-items: start;
}

.content-console-account-shell {
  grid-template-columns: minmax(320px, 420px) minmax(0, 1fr);
  align-items: start;
}

.content-console-sidebar,
.content-console-editor {
  border-radius: var(--console-radius-lg);
  padding: 22px;
  min-width: 0;
}

.content-console-self-management-shell,
.content-console-user-management-shell {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.content-console-account-stack,
.content-console-editor-main,
.content-console-detail-sidebar,
.content-console-user-management-view {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
}

.content-console-user-management-shell-body {
  display: grid;
  grid-template-columns: 360px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
  min-width: 0;
}

.content-console-user-directory {
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: sticky;
  top: 0;
  align-self: start;
}

.content-console-user-directory-head {
  flex-direction: column;
  gap: 14px;
}

.content-console-user-directory-list {
  max-height: min(54dvh, 680px);
  overflow: auto;
  padding-right: 2px;
}

.content-console-user-editor-stage {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.content-console-user-editor-stage-head {
  padding: 18px 20px;
  border: 1px solid var(--console-border);
  border-radius: 20px;
  background: var(--console-surface-muted);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.content-console-mobile-only-action {
  display: none;
}

.content-console-editor-shell {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 18px;
  min-width: 0;
}

.content-console-editor-shell.is-account-editor-shell {
  grid-template-columns: minmax(0, 1fr) 300px;
}

.content-console-panel-head,
.content-console-list-panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.content-console-panel-head.is-vertical {
  flex-direction: column;
}

.content-console-panel-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: var(--console-accent-soft);
  color: var(--console-accent);
  font-size: 12px;
  font-weight: 700;
}

.content-console-panel-head h2,
.content-console-list-panel-copy strong {
  margin: 14px 0 0;
  font-size: 20px;
  line-height: 1.25;
  color: var(--console-text);
}

.content-console-panel-head p,
.content-console-list-panel-copy span {
  margin-top: 10px;
  color: var(--console-text-soft);
  line-height: 1.75;
}

.content-console-list-panel-copy {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.content-console-toolbar-stack,
.content-console-toolbar-cluster,
.content-console-editor-actions,
.content-console-action-row,
.content-console-tabs,
.content-console-locale-tabs,
.content-console-permission-grid,
.content-console-cover-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.content-console-toolbar-stack {
  width: 100%;
  flex-direction: column;
}

.content-console-toolbar-cluster {
  justify-content: space-between;
}

.content-console-editor-actions {
  justify-content: flex-end;
}

.content-console-action-row.is-spaced-top {
  margin-top: 8px;
}

.content-console-search-input,
.content-console-page input,
.content-console-page select,
.content-console-page textarea {
  width: 100%;
  border: 1px solid var(--console-border-strong);
  border-radius: 14px;
  background: #fff;
  color: var(--console-text);
  padding: 12px 14px;
  font: inherit;
  line-height: 1.5;
  box-sizing: border-box;
  transition:
    border-color 160ms ease,
    box-shadow 160ms ease,
    background-color 160ms ease;
}

.content-console-page textarea {
  resize: vertical;
  min-height: 132px;
}

.content-console-page input:focus,
.content-console-page select:focus,
.content-console-page textarea:focus,
.content-console-search-input:focus {
  outline: none;
  border-color: #d95d6f;
  box-shadow: 0 0 0 4px rgba(217, 45, 67, 0.12);
}

.content-console-primary-button,
.content-console-secondary-button,
.content-console-danger-button {
  min-height: 44px;
  border-radius: 14px;
  padding: 0 18px;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
  transition:
    background-color 160ms ease,
    border-color 160ms ease,
    color 160ms ease,
    box-shadow 160ms ease,
    transform 160ms ease;
}

.content-console-primary-button {
  border: 1px solid var(--console-accent);
  background: var(--console-accent);
  color: #fff;
}

.content-console-primary-button:hover:not(:disabled) {
  background: var(--console-accent-strong);
  border-color: var(--console-accent-strong);
}

.content-console-secondary-button {
  border: 1px solid var(--console-border-strong);
  background: #fff;
  color: var(--console-text);
}

.content-console-secondary-button:hover:not(:disabled) {
  border-color: #b9c6d4;
  background: #fafcff;
}

.content-console-danger-button {
  border: 1px solid #f2c7cf;
  background: #fff4f6;
  color: var(--console-accent-strong);
}

.content-console-danger-button:hover:not(:disabled) {
  background: #ffecee;
}

.content-console-primary-button:disabled,
.content-console-secondary-button:disabled,
.content-console-danger-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

.content-console-primary-button.is-block,
.content-console-secondary-button.is-block {
  width: 100%;
  justify-content: center;
}

.content-console-tabs button,
.content-console-locale-tabs button {
  min-height: 42px;
  padding: 0 18px;
  border: 1px solid var(--console-border-strong);
  border-radius: 14px;
  background: #fff;
  color: var(--console-text-soft);
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.content-console-tabs button.is-active,
.content-console-locale-tabs button.is-active {
  background: var(--console-text);
  border-color: var(--console-text);
  color: #fff;
}

.content-console-management-tabs {
  align-self: flex-start;
  display: none;
}

.content-console-editor-mode-tabs {
  margin: 0 0 14px;
  align-self: flex-start;
}

.content-console-list-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 16px;
  margin: 8px 0 10px;
  border: 1px solid var(--console-border);
  border-radius: 16px;
  background: var(--console-surface-muted);
  color: var(--console-text-soft);
  font-size: 14px;
  line-height: 1.5;
}

.content-console-list-summary.is-vertical-summary {
  flex-direction: column;
  align-items: flex-start;
}

.content-console-list-summary.is-vertical-summary > span {
  flex: 0 0 auto;
  width: 100%;
}

.content-console-list-summary > span {
  flex: 1 1 160px;
  min-width: 0;
}

.content-console-list-summary > span:last-child {
  text-align: right;
}

.content-console-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 160px;
}

.content-console-empty {
  padding: 24px 18px;
  border: 1px dashed var(--console-border-strong);
  border-radius: 16px;
  background: var(--console-surface-muted);
  color: var(--console-text-soft);
  text-align: center;
}

.content-console-list-item {
  width: 100%;
  padding: 16px;
  border: 1px solid var(--console-border);
  border-radius: 18px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;
  cursor: pointer;
  transition:
    border-color 160ms ease,
    box-shadow 160ms ease,
    transform 160ms ease;
}

.content-console-list-item:hover {
  border-color: #f0c5cd;
  box-shadow: 0 12px 24px rgba(217, 45, 67, 0.08);
}

.content-console-list-item.is-active {
  border-color: #ef8d9c;
  background: #fff8f9;
}

.content-console-list-item-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.content-console-list-item strong {
  font-size: 16px;
  line-height: 1.5;
  color: var(--console-text);
}

.content-console-list-item span,
.content-console-list-item small,
.content-console-user-list-login,
.content-console-user-list-meta small {
  color: var(--console-text-soft);
}

.content-console-status-badge {
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  background: var(--console-warning-soft);
  color: #8a5c00;
  white-space: nowrap;
}

.content-console-status-badge.is-published {
  background: var(--console-success-soft);
  color: var(--console-success);
}

.content-console-status-badge.is-draft {
  background: var(--console-danger-soft);
  color: var(--console-accent-strong);
}

.content-console-user-list-meta {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.content-console-section-card {
  padding: 20px;
  border-radius: 22px;
}

.content-console-section-card.is-sidebar-card,
.content-console-section-card.is-compact {
  padding: 18px;
}

.content-console-section-head {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 18px;
}

.content-console-section-head.is-inline-head {
  margin-bottom: 18px;
}

.content-console-section-head h3 {
  margin: 0;
  font-size: 17px;
  color: var(--console-text);
}

.content-console-section-head p,
.content-console-inline-help {
  color: var(--console-text-soft);
  line-height: 1.75;
}

.content-console-form-grid {
  display: grid;
  gap: 16px;
}

.content-console-form-grid.is-common,
.content-console-form-grid.is-two-column {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.content-console-form-grid.is-single-column,
.content-console-form-grid.is-single-column-grid,
.content-console-form-grid.is-full,
.content-console-permission-grid.is-single-column-grid {
  grid-template-columns: minmax(0, 1fr);
}

.content-console-page label {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.content-console-page label > span:first-child,
.content-console-checkbox > span,
.content-console-inline-check span strong,
.content-console-inline-check span small {
  min-width: 0;
}

.content-console-page label > span:first-child {
  font-size: 14px;
  font-weight: 700;
  color: var(--console-text);
}

.content-console-checkbox-row,
.content-console-inline-check {
  display: flex;
  align-items: center;
  gap: 10px;
}

.content-console-checkbox-row {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: center;
  column-gap: 10px;
  min-height: 24px;
  width: 100%;
}

.content-console-checkbox-row input {
  margin: 0;
  flex-shrink: 0;
}

.content-console-checkbox-row span {
  display: block;
  min-width: 0;
  line-height: 1.5;
}

.content-console-inline-check {
  padding: 12px 14px;
  border: 1px solid var(--console-border);
  border-radius: 14px;
  background: var(--console-surface-muted);
}

.content-console-inline-check.is-card-check {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: start;
  column-gap: 12px;
  row-gap: 0;
}

.content-console-inline-check input {
  margin: 0;
  flex-shrink: 0;
}

.content-console-inline-check.is-card-check input {
  margin: 3px 0 0;
  justify-self: start;
}

.content-console-inline-check span {
  display: block;
  color: var(--console-text-soft);
  line-height: 1.45;
}

.content-console-inline-check.is-card-check span {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.content-console-inline-check strong {
  color: var(--console-text);
}

.content-console-inline-check small {
  line-height: 1.45;
}

.content-console-check-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.content-console-check-grid.is-stacked {
  grid-template-columns: minmax(0, 1fr);
}

.content-console-cover-panel {
  display: grid;
  grid-template-columns: minmax(220px, 320px) minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}

.content-console-cover-preview {
  aspect-ratio: 4 / 3;
  border: 1px dashed var(--console-border-strong);
  border-radius: 18px;
  background: var(--console-surface-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: var(--console-text-faint);
}

.content-console-cover-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-console-cover-actions {
  align-items: flex-start;
}

.content-console-locale-card,
.content-console-note-card {
  padding: 16px;
  border-radius: 18px;
}

.content-console-locale-note {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.content-console-meta-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.content-console-meta-list div {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebf0f5;
}

.content-console-meta-list div:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.content-console-meta-list dt {
  color: var(--console-text-faint);
}

.content-console-meta-list dd {
  margin: 0;
  color: var(--console-text);
  font-weight: 700;
  text-align: right;
}

.content-console-permission-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.content-console-permission-chip {
  padding: 14px;
  border: 1px solid var(--console-border);
  border-radius: 16px;
  background: var(--console-surface-muted);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.content-console-permission-chip strong {
  color: var(--console-text);
}

.content-console-permission-chip span {
  color: var(--console-text-soft);
}

.content-console-permission-chip.is-enabled {
  border-color: #efc4cc;
  background: #fff7f8;
}

.content-console-user-management-view .content-console-sidebar.is-inner-sidebar {
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.content-console-user-directory.content-console-sidebar.is-inner-sidebar {
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.content-console-user-management-view .content-console-list-panel-head,
.content-console-user-management-view .content-console-list,
.content-console-user-management-view .content-console-pagination {
  padding: 20px;
  border-radius: 22px;
  background: var(--console-surface);
  border: 1px solid var(--console-border);
  box-shadow: var(--console-shadow-soft);
}

.content-console-user-management-view .content-console-list {
  padding: 16px;
}

.content-console-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.content-console-pagination-pages {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.content-console-pagination-arrow,
.content-console-pagination-page {
  min-width: 42px;
  height: 42px;
  border: 1px solid var(--console-border-strong);
  border-radius: 12px;
  background: #fff;
  color: var(--console-text);
  cursor: pointer;
  font: inherit;
}

.content-console-pagination-page.is-active {
  border-color: var(--console-accent);
  background: var(--console-accent);
  color: #fff;
}

.content-console-pagination-arrow:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.content-console-pagination-gap {
  color: var(--console-text-faint);
}

.content-console-login-shell {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  box-sizing: border-box;
}

.content-console-login-card {
  width: min(480px, 100%);
  padding: 28px;
  border-radius: 28px;
  background: var(--console-surface);
  border: 1px solid var(--console-border);
  box-shadow: var(--console-shadow);
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.content-console-brand-block {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 4px;
}

.content-console-brand-block h1 {
  margin: 8px 0 0;
  font-size: 28px;
  color: var(--console-text);
}

.content-console-brand-block p {
  margin-top: 12px;
  color: var(--console-text-soft);
  line-height: 1.75;
}

@media (max-width: 1279px) {
  .content-console-main-shell {
    padding: 24px;
  }

  .content-console-layout,
  .content-console-account-shell,
  .content-console-user-management-shell-body,
  .content-console-editor-shell,
  .content-console-editor-shell.is-account-editor-shell,
  .content-console-cover-panel {
    grid-template-columns: minmax(0, 1fr);
  }

  .content-console-page-header,
  .content-console-list-panel-head,
  .content-console-panel-head,
  .content-console-toolbar-cluster,
  .content-console-user-editor-stage-head {
    flex-direction: column;
  }

  .content-console-page-header-meta,
  .content-console-summary-grid.is-three-column,
  .content-console-permission-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1023px) {
  body.content-console-body {
    overflow: hidden;
  }

  .content-console-mobile-toggle {
    position: fixed;
    top: 18px;
    left: 18px;
    z-index: 55;
    display: inline-flex;
    width: auto;
    padding: 0 14px;
    font-size: 14px;
    font-weight: 700;
  }

  .content-console-sidebar-icon-button.is-desktop-only {
    display: none;
  }

  .content-console-sidebar-icon-button.is-mobile-only {
    display: inline-flex;
  }

  .content-console-app-sidebar {
    width: min(320px, calc(100vw - 32px));
    transform: translateX(-100%);
    box-shadow: var(--console-shadow);
  }

  .content-console-page.has-mobile-sidebar-open .content-console-app-sidebar {
    transform: translateX(0);
  }

  .content-console-main-shell,
  .content-console-page.is-sidebar-collapsed .content-console-main-shell {
    inset: 0;
    padding: 76px 18px 18px;
  }

  .content-console-mobile-backdrop {
    position: absolute;
    inset: 0;
    display: block;
    background: rgba(15, 23, 42, 0.22);
    border: 0;
    z-index: 35;
    cursor: pointer;
  }

  .content-console-page-header-meta,
  .content-console-summary-grid.is-three-column,
  .content-console-form-grid.is-common,
  .content-console-form-grid.is-two-column,
  .content-console-check-grid,
  .content-console-permission-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .content-console-tabs,
  .content-console-management-tabs,
  .content-console-locale-tabs,
  .content-console-editor-actions,
  .content-console-action-row,
  .content-console-cover-actions,
  .content-console-user-editor-stage-head {
    flex-direction: column;
  }

  .content-console-tabs button,
  .content-console-locale-tabs button,
  .content-console-primary-button,
  .content-console-secondary-button,
  .content-console-danger-button {
    width: 100%;
  }

  .content-console-mobile-only-action {
    display: inline-flex;
  }

  .content-console-management-tabs {
    display: flex;
    align-self: stretch;
  }

  .content-console-user-directory.is-mobile-hidden,
  .content-console-user-editor-stage.is-mobile-hidden {
    display: none;
  }
}

@media (max-width: 767px) {
  .content-console-page-header-copy h2 {
    font-size: 24px;
  }

  .content-console-sidebar,
  .content-console-editor,
  .content-console-section-card,
  .content-console-user-management-view .content-console-list-panel-head,
  .content-console-user-management-view .content-console-list,
  .content-console-user-management-view .content-console-pagination {
    border-radius: 18px;
  }

  .content-console-list-item-top,
  .content-console-user-list-meta,
  .content-console-meta-list div,
  .content-console-pagination,
  .content-console-list-summary {
    flex-direction: column;
    align-items: flex-start;
  }

  .content-console-list-summary > span:last-child {
    text-align: left;
  }

  .content-console-pagination-pages {
    justify-content: flex-start;
  }
}

.content-console-summary-grid.is-four-column {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.content-console-summary-grid.is-five-column {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.content-console-tight-grid {
  margin-top: 16px;
}

.content-console-cover-preview.is-qr-preview {
  aspect-ratio: 1 / 1;
  max-width: 280px;
}

.content-console-cropper-overlay {
  position: fixed;
  inset: 0;
  z-index: 120;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.48);
  backdrop-filter: blur(6px);
}

.content-console-cropper-dialog {
  width: min(920px, 100%);
  max-height: calc(100dvh - 48px);
  overflow: auto;
  padding: 24px;
  border-radius: 28px;
  background: var(--console-surface);
  border: 1px solid var(--console-border);
  box-shadow: var(--console-shadow);
  display: grid;
  gap: 20px;
}

.content-console-cropper-head,
.content-console-cropper-controls,
.content-console-cropper-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.content-console-cropper-head h3 {
  margin: 0;
  font-size: 22px;
  color: var(--console-text);
}

.content-console-cropper-head p {
  margin: 8px 0 0;
  color: var(--console-text-soft);
  line-height: 1.7;
}

.content-console-cropper-stage {
  padding: 24px;
  border-radius: 22px;
  background:
    linear-gradient(135deg, rgba(217, 45, 67, 0.08), rgba(19, 34, 56, 0.06)),
    var(--console-surface-muted);
  border: 1px solid var(--console-border);
  overflow: auto;
}

.content-console-cropper-viewport {
  position: relative;
  margin: 0 auto;
  border-radius: 24px;
  overflow: hidden;
  background:
    linear-gradient(45deg, #eef2f7 25%, transparent 25%),
    linear-gradient(-45deg, #eef2f7 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #eef2f7 75%),
    linear-gradient(-45deg, transparent 75%, #eef2f7 75%);
  background-size: 24px 24px;
  background-position: 0 0, 0 12px, 12px -12px, -12px 0;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55);
  touch-action: none;
  cursor: grab;
  user-select: none;
}

.content-console-cropper-viewport.is-dragging {
  cursor: grabbing;
}

.content-console-cropper-viewport::after {
  content: '';
  position: absolute;
  inset: 0;
  border: 2px solid rgba(255, 255, 255, 0.92);
  border-radius: inherit;
  box-shadow: inset 0 0 0 9999px rgba(15, 23, 42, 0.12);
  pointer-events: none;
}

.content-console-cropper-viewport img {
  position: absolute;
  top: 0;
  left: 0;
  max-width: none;
  max-height: none;
  pointer-events: none;
}

.content-console-cropper-zoom {
  flex: 1 1 260px;
  display: grid;
  gap: 8px;
}

.content-console-cropper-zoom span {
  font-size: 14px;
  font-weight: 700;
  color: var(--console-text);
}

.content-console-cropper-zoom input[type=range] {
  width: 100%;
  padding: 0;
  border: 0;
  box-shadow: none;
  background: transparent;
}

.content-console-requirement-stack {
  display: grid;
  gap: 18px;
}

.content-console-requirement-card {
  padding: 18px;
  border-radius: 18px;
  border: 1px solid var(--console-border);
  background: var(--console-surface-muted);
  display: grid;
  gap: 16px;
}

.content-console-requirement-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.content-console-requirement-card-head strong {
  font-size: 16px;
  color: var(--console-text);
}

.content-console-span-two {
  grid-column: 1 / -1;
}

.content-console-requirement-placeholder {
  display: none;
}

@media (max-width: 1279px) {
  .content-console-summary-grid.is-four-column {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .content-console-summary-grid.is-five-column {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .content-console-summary-grid.is-four-column {
    grid-template-columns: minmax(0, 1fr);
  }

  .content-console-summary-grid.is-five-column {
    grid-template-columns: minmax(0, 1fr);
  }

  .content-console-requirement-card-head {
    flex-direction: column;
    align-items: flex-start;
  }

  .content-console-cropper-overlay {
    padding: 16px;
  }

  .content-console-cropper-dialog {
    padding: 18px;
    border-radius: 20px;
  }

  .content-console-cropper-head,
  .content-console-cropper-controls,
  .content-console-cropper-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .content-console-cropper-stage {
    padding: 12px;
  }
}

.content-console-account-shell.is-self-only {
  grid-template-columns: minmax(0, 1fr);
}

.content-console-account-shell.is-self-only .content-console-self-management-shell {
  width: 100%;
}

.content-console-permission-chip small {
  color: var(--console-text-faint);
  line-height: 1.45;
}

.content-console-sidebar .content-console-locale-tabs {
  width: 100%;
}

.content-console-sidebar .content-console-locale-tabs button {
  flex: 1 1 0;
}


.content-console-analytics-shell {
  display: grid;
  gap: 24px;
}

.analytics-hero-card,
.analytics-chart-card {
  overflow: hidden;
}

.analytics-hero-head {
  align-items: flex-start;
}

.analytics-summary-grid {
  margin-top: 18px;
}

.analytics-chart-grid,
.analytics-ranking-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}

.analytics-chart-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.analytics-chart-meta div,
.analytics-ranking-item {
  padding: 14px 16px;
  border: 1px solid var(--console-border);
  border-radius: 16px;
  background: var(--console-surface-muted);
}

.analytics-chart-meta span,
.analytics-ranking-item span {
  display: block;
  color: var(--console-text-soft);
}

.analytics-chart-meta strong,
.analytics-ranking-item strong {
  color: var(--console-text);
}

.analytics-line-chart-shell {
  height: 240px;
  border-radius: 20px;
  border: 1px solid var(--console-border);
  background:
    linear-gradient(to bottom, rgba(217, 45, 67, 0.04), rgba(255, 255, 255, 0.9)),
    repeating-linear-gradient(to top, transparent, transparent 47px, rgba(19, 34, 56, 0.06) 48px);
  padding: 16px;
  box-sizing: border-box;
}

.analytics-line-chart {
  width: 100%;
  height: 100%;
  overflow: visible;
}

.analytics-chart-labels {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  color: var(--console-text-faint);
  font-size: 13px;
}

.analytics-ranking-list {
  display: grid;
  gap: 12px;
}

.analytics-ranking-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.analytics-ranking-metrics {
  text-align: right;
}

@media (max-width: 1279px) {
  .analytics-chart-grid,
  .analytics-ranking-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 767px) {
  .analytics-chart-meta,
  .analytics-ranking-item {
    grid-template-columns: minmax(0, 1fr);
  }

  .analytics-ranking-item {
    flex-direction: column;
  }

  .analytics-ranking-metrics {
    text-align: left;
  }
}


`, "",{"version":3,"sources":["webpack://./src/styles/content-console.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,gCAAgC;EAChC,yBAAyB;EACzB,gCAAgC;EAChC,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,oDAAoD;EACpD,yDAAyD;EACzD,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,kCAAkC;EAClC,6CAA6C;EAC7C,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX;;wBAEsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;;;;yBAIuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB;;;;wBAIsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;;;;;;EAME,kCAAkC;EAClC,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;AACpB;;AAEA;;EAEE,uCAAuC;EACvC,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,YAAY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;EACtC,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;;;;;;EAQE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;EACX,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB;;;+BAG6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;EAIE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf;;;;;wBAKsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf;;;wBAGsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,uCAAuC;EACvC,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;;;;IAME,qCAAqC;EACvC;;EAEA;;;;;IAKE,sBAAsB;EACxB;;EAEA;;;IAGE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;IACrC,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,kCAAkC;IAClC,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;;;;;;IAME,qCAAqC;EACvC;;EAEA;;;;;;;IAOE,sBAAsB;EACxB;;EAEA;;;;;IAKE,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;;;;;IAME,mBAAmB;EACrB;;EAEA;;;;;IAKE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,uCAAuC;EACvC,iCAAiC;EACjC,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;;gCAE8B;EAC9B,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB;;;;yDAIuD;EACvD,0BAA0B;EAC1B,qDAAqD;EACrD,qDAAqD;EACrD,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2CAA2C;EAC3C,sBAAsB;EACtB,qDAAqD;EACrD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,wCAAwC;EACxC,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;;;IAGE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;;EAEE,cAAc;EACd,+BAA+B;AACjC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC;;iGAE+F;EAC/F,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;IAEE,qCAAqC;EACvC;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[":root {\r\n  --console-bg: #f4f6fb;\r\n  --console-surface: #ffffff;\r\n  --console-surface-muted: #f8fafc;\r\n  --console-border: #d8e0ea;\r\n  --console-border-strong: #c7d1dd;\r\n  --console-text: #132238;\r\n  --console-text-soft: #5c6b80;\r\n  --console-text-faint: #7c8ba1;\r\n  --console-accent: #d92d43;\r\n  --console-accent-strong: #b61f33;\r\n  --console-accent-soft: #fff1f3;\r\n  --console-success: #0b7a54;\r\n  --console-success-soft: #e8f8f1;\r\n  --console-warning-soft: #fff7e8;\r\n  --console-danger-soft: #fff0f2;\r\n  --console-shadow: 0 18px 48px rgba(15, 23, 42, 0.08);\r\n  --console-shadow-soft: 0 10px 24px rgba(15, 23, 42, 0.06);\r\n  --console-radius-lg: 24px;\r\n  --console-radius-md: 16px;\r\n  --console-radius-sm: 12px;\r\n  --console-open-sidebar-width: 288px;\r\n  --console-collapsed-sidebar-width: 92px;\r\n}\r\n\r\nhtml,\r\nbody.content-console-body {\r\n  width: 100%;\r\n  min-height: 100%;\r\n  height: 100%;\r\n}\r\n\r\nbody.content-console-body {\r\n  overflow: hidden;\r\n  background: var(--console-bg);\r\n}\r\n\r\n#root.content-console-root {\r\n  width: 100vw;\r\n  max-width: none;\r\n  min-width: 100vw;\r\n  min-height: 100dvh;\r\n  height: 100dvh;\r\n  margin: 0;\r\n  border: 0;\r\n  display: block;\r\n  text-align: left;\r\n}\r\n\r\n.content-console-page {\r\n  position: fixed;\r\n  inset: 0;\r\n  min-height: 100dvh;\r\n  background: var(--console-bg);\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-app-shell {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.content-console-app-sidebar {\r\n  position: absolute;\r\n  inset: 0 auto 0 0;\r\n  width: var(--console-open-sidebar-width);\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  padding: 16px 14px 14px;\r\n  background: var(--console-surface);\r\n  border-right: 1px solid var(--console-border);\r\n  box-sizing: border-box;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  z-index: 40;\r\n  transition:\r\n    width 220ms ease,\r\n    transform 220ms ease;\r\n}\r\n\r\n.content-console-main-shell {\r\n  position: absolute;\r\n  inset: 0 0 0 var(--console-open-sidebar-width);\r\n  overflow: auto;\r\n  padding: 32px;\r\n  box-sizing: border-box;\r\n  transition: inset 220ms ease;\r\n}\r\n\r\n.content-console-page.is-sidebar-collapsed .content-console-app-sidebar {\r\n  width: var(--console-collapsed-sidebar-width);\r\n  padding-inline: 12px;\r\n}\r\n\r\n.content-console-page.is-sidebar-collapsed .content-console-main-shell {\r\n  inset: 0 0 0 var(--console-collapsed-sidebar-width);\r\n}\r\n\r\n.content-console-mobile-toggle,\r\n.content-console-mobile-backdrop {\r\n  display: none;\r\n}\r\n\r\n.content-console-sidebar-topbar {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.content-console-sidebar-brand {\r\n  min-width: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.content-console-brand-logo {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 14px;\r\n  object-fit: contain;\r\n  flex-shrink: 0;\r\n  background: #fff;\r\n  border: 1px solid var(--console-border);\r\n  box-shadow: var(--console-shadow-soft);\r\n}\r\n\r\n.content-console-sidebar-brand-copy {\r\n  min-width: 0;\r\n}\r\n\r\n.content-console-sidebar-brand-copy h1 {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  line-height: 1.2;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-sidebar-topbar-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.content-console-sidebar-icon-button,\r\n.content-console-mobile-toggle {\r\n  width: 44px;\r\n  height: 44px;\r\n  border: 1px solid var(--console-border-strong);\r\n  border-radius: 14px;\r\n  background: var(--console-surface);\r\n  color: var(--console-text-soft);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition:\r\n    background-color 160ms ease,\r\n    border-color 160ms ease,\r\n    color 160ms ease,\r\n    box-shadow 160ms ease;\r\n}\r\n\r\n.content-console-sidebar-icon-button:hover,\r\n.content-console-mobile-toggle:hover {\r\n  border-color: #b6c3d4;\r\n  color: var(--console-text);\r\n  box-shadow: var(--console-shadow-soft);\r\n}\r\n\r\n.content-console-sidebar-icon-button svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.content-console-sidebar-icon-button.is-mobile-only {\r\n  display: none;\r\n}\r\n\r\n.content-console-sidebar-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  min-width: 0;\r\n  padding: 0;\r\n}\r\n\r\n.content-console-sidebar-label {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.08em;\r\n  color: var(--console-text-faint);\r\n}\r\n\r\n.content-console-sidebar-nav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.content-console-sidebar-nav-item {\r\n  width: 100%;\r\n  border: 1px solid transparent;\r\n  border-radius: 14px;\r\n  background: transparent;\r\n  padding: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  transition:\r\n    background-color 160ms ease,\r\n    border-color 160ms ease,\r\n    box-shadow 160ms ease,\r\n    transform 160ms ease;\r\n}\r\n\r\n.content-console-sidebar-nav-item:hover:not(:disabled) {\r\n  background: #fff8f8;\r\n  border-color: #f2d4d9;\r\n}\r\n\r\n.content-console-sidebar-nav-item:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.content-console-sidebar-nav-item.is-active {\r\n  background: #fff6f7;\r\n  border-color: #f0c6ce;\r\n  box-shadow: 0 10px 24px rgba(217, 45, 67, 0.08);\r\n}\r\n\r\n.content-console-sidebar-nav-rail {\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 10px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  background: #f3b6bf;\r\n  color: #ffffff;\r\n  transition: background-color 160ms ease, transform 160ms ease;\r\n}\r\n\r\n.content-console-sidebar-nav-item.is-active .content-console-sidebar-nav-rail {\r\n  background: var(--console-accent);\r\n}\r\n\r\n.content-console-sidebar-nav-item:hover .content-console-sidebar-nav-rail {\r\n  background: var(--console-accent-strong);\r\n}\r\n\r\n.content-console-sidebar-nav-rail svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.content-console-sidebar-nav-copy {\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.content-console-sidebar-nav-copy strong {\r\n  font-size: 15px;\r\n  line-height: 1.2;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-sidebar-nav-copy span {\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n  color: var(--console-text-soft);\r\n}\r\n\r\n.content-console-sidebar-user-card {\r\n  padding: 14px;\r\n  border: 1px solid var(--console-border);\r\n  border-radius: 16px;\r\n  background: var(--console-surface-muted);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.content-console-sidebar-user-card strong {\r\n  display: block;\r\n  margin-bottom: 4px;\r\n  font-size: 16px;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-sidebar-user-card span {\r\n  color: var(--console-text-soft);\r\n}\r\n\r\n.content-console-sidebar-role {\r\n  align-self: flex-start;\r\n  padding: 6px 10px;\r\n  border-radius: 999px;\r\n  background: #eef2f7;\r\n  color: var(--console-text-soft);\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n}\r\n\r\n.content-console-sidebar-role.is-super {\r\n  background: var(--console-accent-soft);\r\n  color: var(--console-accent-strong);\r\n}\r\n\r\n.content-console-sidebar-permissions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.content-console-mini-tag {\r\n  padding: 6px 10px;\r\n  border-radius: 999px;\r\n  background: #eef2f7;\r\n  color: var(--console-text-soft);\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n}\r\n\r\n.content-console-mini-tag.is-enabled {\r\n  background: var(--console-accent-soft);\r\n  color: var(--console-accent-strong);\r\n}\r\n\r\n.content-console-sidebar-footer {\r\n  margin-top: 6px;\r\n}\r\n\r\n.content-console-page.is-sidebar-collapsed .content-console-sidebar-brand-copy,\r\n.content-console-page.is-sidebar-collapsed .content-console-sidebar-label,\r\n.content-console-page.is-sidebar-collapsed .content-console-sidebar-user-card,\r\n.content-console-page.is-sidebar-collapsed .content-console-sidebar-permissions,\r\n.content-console-page.is-sidebar-collapsed .content-console-sidebar-footer {\r\n  display: none;\r\n}\r\n\r\n.content-console-page.is-sidebar-collapsed .content-console-app-sidebar .content-console-sidebar-section:not(:first-of-type) {\r\n  display: none;\r\n}\r\n\r\n.content-console-page.is-sidebar-collapsed .content-console-sidebar-topbar {\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.content-console-page.is-sidebar-collapsed .content-console-sidebar-brand {\r\n  justify-content: center;\r\n}\r\n\r\n.content-console-page.is-sidebar-collapsed .content-console-sidebar-nav-item {\r\n  justify-content: center;\r\n  padding: 10px;\r\n}\r\n\r\n.content-console-page.is-sidebar-collapsed .content-console-sidebar-nav-copy {\r\n  display: none;\r\n}\r\n\r\n.content-console-page.is-sidebar-collapsed .content-console-sidebar-section {\r\n  align-items: center;\r\n}\r\n\r\n.content-console-page-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 24px;\r\n  margin-bottom: 18px;\r\n  padding: 0;\r\n}\r\n\r\n.content-console-page-header-copy {\r\n  max-width: 720px;\r\n}\r\n\r\n.content-console-kicker {\r\n  display: inline-block;\r\n  margin-bottom: 6px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.16em;\r\n  text-transform: uppercase;\r\n  color: var(--console-accent);\r\n}\r\n\r\n.content-console-page-header-copy h2 {\r\n  margin: 0;\r\n  font-size: 28px;\r\n  line-height: 1.15;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-page-header-copy p {\r\n  margin-top: 8px;\r\n  max-width: 680px;\r\n  color: var(--console-text-soft);\r\n  line-height: 1.65;\r\n}\r\n\r\n.content-console-page-header-meta {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(120px, 1fr));\r\n  gap: 8px;\r\n  min-width: min(420px, 100%);\r\n}\r\n\r\n.content-console-page-header-stat,\r\n.content-console-summary-card,\r\n.content-console-section-card,\r\n.content-console-sidebar,\r\n.content-console-editor,\r\n.content-console-note-card {\r\n  background: var(--console-surface);\r\n  border: 1px solid var(--console-border);\r\n  box-shadow: var(--console-shadow-soft);\r\n}\r\n\r\n.content-console-page-header-stat {\r\n  padding: 12px 14px;\r\n  border-radius: 18px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  gap: 2px;\r\n}\r\n\r\n.content-console-page-header-stat span {\r\n  font-size: 13px;\r\n  color: var(--console-text-faint);\r\n  line-height: 1.3;\r\n}\r\n\r\n.content-console-page-header-stat strong {\r\n  font-size: 15px;\r\n  line-height: 1.2;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-summary-grid {\r\n  display: grid;\r\n  gap: 12px;\r\n  margin-bottom: 14px;\r\n  align-items: start;\r\n  padding: 0;\r\n}\r\n\r\n.content-console-summary-grid.is-three-column {\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n}\r\n\r\n.content-console-summary-card {\r\n  padding: 12px 16px;\r\n  border-radius: 18px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  gap: 2px;\r\n}\r\n\r\n.content-console-summary-card span {\r\n  display: block;\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: var(--console-text-faint);\r\n  line-height: 1.25;\r\n}\r\n\r\n.content-console-summary-card strong {\r\n  display: block;\r\n  margin: 0;\r\n  font-size: 30px;\r\n  line-height: 1;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-summary-card p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  line-height: 1.35;\r\n  color: var(--console-text-soft);\r\n}\r\n\r\n.content-console-feedback {\r\n  margin-bottom: 24px;\r\n  padding: 14px 16px;\r\n  border-radius: 16px;\r\n  border: 1px solid #c8d5e3;\r\n  background: #edf5ff;\r\n  color: #0f3a67;\r\n}\r\n\r\n.content-console-feedback.is-error {\r\n  border-color: #efc1cb;\r\n  background: #fff1f3;\r\n  color: #8a2332;\r\n}\r\n\r\n.content-console-feedback.is-success {\r\n  border-color: #bde6d6;\r\n  background: #effcf6;\r\n  color: #096344;\r\n}\r\n\r\n.content-console-layout,\r\n.content-console-account-shell {\r\n  display: grid;\r\n  gap: 24px;\r\n}\r\n\r\n.content-console-layout {\r\n  grid-template-columns: 340px minmax(0, 1fr);\r\n  align-items: start;\r\n}\r\n\r\n.content-console-account-shell {\r\n  grid-template-columns: minmax(320px, 420px) minmax(0, 1fr);\r\n  align-items: start;\r\n}\r\n\r\n.content-console-sidebar,\r\n.content-console-editor {\r\n  border-radius: var(--console-radius-lg);\r\n  padding: 22px;\r\n  min-width: 0;\r\n}\r\n\r\n.content-console-self-management-shell,\r\n.content-console-user-management-shell {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 22px;\r\n}\r\n\r\n.content-console-account-stack,\r\n.content-console-editor-main,\r\n.content-console-detail-sidebar,\r\n.content-console-user-management-view {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n  min-width: 0;\r\n}\r\n\r\n.content-console-user-management-shell-body {\r\n  display: grid;\r\n  grid-template-columns: 360px minmax(0, 1fr);\r\n  gap: 18px;\r\n  align-items: start;\r\n  min-width: 0;\r\n}\r\n\r\n.content-console-user-directory {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  position: sticky;\r\n  top: 0;\r\n  align-self: start;\r\n}\r\n\r\n.content-console-user-directory-head {\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.content-console-user-directory-list {\r\n  max-height: min(54dvh, 680px);\r\n  overflow: auto;\r\n  padding-right: 2px;\r\n}\r\n\r\n.content-console-user-editor-stage {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  min-width: 0;\r\n}\r\n\r\n.content-console-user-editor-stage-head {\r\n  padding: 18px 20px;\r\n  border: 1px solid var(--console-border);\r\n  border-radius: 20px;\r\n  background: var(--console-surface-muted);\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n}\r\n\r\n.content-console-mobile-only-action {\r\n  display: none;\r\n}\r\n\r\n.content-console-editor-shell {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) 320px;\r\n  gap: 18px;\r\n  min-width: 0;\r\n}\r\n\r\n.content-console-editor-shell.is-account-editor-shell {\r\n  grid-template-columns: minmax(0, 1fr) 300px;\r\n}\r\n\r\n.content-console-panel-head,\r\n.content-console-list-panel-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n}\r\n\r\n.content-console-panel-head.is-vertical {\r\n  flex-direction: column;\r\n}\r\n\r\n.content-console-panel-tag {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 6px 10px;\r\n  border-radius: 999px;\r\n  background: var(--console-accent-soft);\r\n  color: var(--console-accent);\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n}\r\n\r\n.content-console-panel-head h2,\r\n.content-console-list-panel-copy strong {\r\n  margin: 14px 0 0;\r\n  font-size: 20px;\r\n  line-height: 1.25;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-panel-head p,\r\n.content-console-list-panel-copy span {\r\n  margin-top: 10px;\r\n  color: var(--console-text-soft);\r\n  line-height: 1.75;\r\n}\r\n\r\n.content-console-list-panel-copy {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.content-console-toolbar-stack,\r\n.content-console-toolbar-cluster,\r\n.content-console-editor-actions,\r\n.content-console-action-row,\r\n.content-console-tabs,\r\n.content-console-locale-tabs,\r\n.content-console-permission-grid,\r\n.content-console-cover-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 12px;\r\n}\r\n\r\n.content-console-toolbar-stack {\r\n  width: 100%;\r\n  flex-direction: column;\r\n}\r\n\r\n.content-console-toolbar-cluster {\r\n  justify-content: space-between;\r\n}\r\n\r\n.content-console-editor-actions {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.content-console-action-row.is-spaced-top {\r\n  margin-top: 8px;\r\n}\r\n\r\n.content-console-search-input,\r\n.content-console-page input,\r\n.content-console-page select,\r\n.content-console-page textarea {\r\n  width: 100%;\r\n  border: 1px solid var(--console-border-strong);\r\n  border-radius: 14px;\r\n  background: #fff;\r\n  color: var(--console-text);\r\n  padding: 12px 14px;\r\n  font: inherit;\r\n  line-height: 1.5;\r\n  box-sizing: border-box;\r\n  transition:\r\n    border-color 160ms ease,\r\n    box-shadow 160ms ease,\r\n    background-color 160ms ease;\r\n}\r\n\r\n.content-console-page textarea {\r\n  resize: vertical;\r\n  min-height: 132px;\r\n}\r\n\r\n.content-console-page input:focus,\r\n.content-console-page select:focus,\r\n.content-console-page textarea:focus,\r\n.content-console-search-input:focus {\r\n  outline: none;\r\n  border-color: #d95d6f;\r\n  box-shadow: 0 0 0 4px rgba(217, 45, 67, 0.12);\r\n}\r\n\r\n.content-console-primary-button,\r\n.content-console-secondary-button,\r\n.content-console-danger-button {\r\n  min-height: 44px;\r\n  border-radius: 14px;\r\n  padding: 0 18px;\r\n  font: inherit;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  transition:\r\n    background-color 160ms ease,\r\n    border-color 160ms ease,\r\n    color 160ms ease,\r\n    box-shadow 160ms ease,\r\n    transform 160ms ease;\r\n}\r\n\r\n.content-console-primary-button {\r\n  border: 1px solid var(--console-accent);\r\n  background: var(--console-accent);\r\n  color: #fff;\r\n}\r\n\r\n.content-console-primary-button:hover:not(:disabled) {\r\n  background: var(--console-accent-strong);\r\n  border-color: var(--console-accent-strong);\r\n}\r\n\r\n.content-console-secondary-button {\r\n  border: 1px solid var(--console-border-strong);\r\n  background: #fff;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-secondary-button:hover:not(:disabled) {\r\n  border-color: #b9c6d4;\r\n  background: #fafcff;\r\n}\r\n\r\n.content-console-danger-button {\r\n  border: 1px solid #f2c7cf;\r\n  background: #fff4f6;\r\n  color: var(--console-accent-strong);\r\n}\r\n\r\n.content-console-danger-button:hover:not(:disabled) {\r\n  background: #ffecee;\r\n}\r\n\r\n.content-console-primary-button:disabled,\r\n.content-console-secondary-button:disabled,\r\n.content-console-danger-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  box-shadow: none;\r\n}\r\n\r\n.content-console-primary-button.is-block,\r\n.content-console-secondary-button.is-block {\r\n  width: 100%;\r\n  justify-content: center;\r\n}\r\n\r\n.content-console-tabs button,\r\n.content-console-locale-tabs button {\r\n  min-height: 42px;\r\n  padding: 0 18px;\r\n  border: 1px solid var(--console-border-strong);\r\n  border-radius: 14px;\r\n  background: #fff;\r\n  color: var(--console-text-soft);\r\n  font: inherit;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n\r\n.content-console-tabs button.is-active,\r\n.content-console-locale-tabs button.is-active {\r\n  background: var(--console-text);\r\n  border-color: var(--console-text);\r\n  color: #fff;\r\n}\r\n\r\n.content-console-management-tabs {\r\n  align-self: flex-start;\r\n  display: none;\r\n}\r\n\r\n.content-console-editor-mode-tabs {\r\n  margin: 0 0 14px;\r\n  align-self: flex-start;\r\n}\r\n\r\n.content-console-list-summary {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  padding: 14px 16px;\r\n  margin: 8px 0 10px;\r\n  border: 1px solid var(--console-border);\r\n  border-radius: 16px;\r\n  background: var(--console-surface-muted);\r\n  color: var(--console-text-soft);\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.content-console-list-summary.is-vertical-summary {\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.content-console-list-summary.is-vertical-summary > span {\r\n  flex: 0 0 auto;\r\n  width: 100%;\r\n}\r\n\r\n.content-console-list-summary > span {\r\n  flex: 1 1 160px;\r\n  min-width: 0;\r\n}\r\n\r\n.content-console-list-summary > span:last-child {\r\n  text-align: right;\r\n}\r\n\r\n.content-console-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  min-height: 160px;\r\n}\r\n\r\n.content-console-empty {\r\n  padding: 24px 18px;\r\n  border: 1px dashed var(--console-border-strong);\r\n  border-radius: 16px;\r\n  background: var(--console-surface-muted);\r\n  color: var(--console-text-soft);\r\n  text-align: center;\r\n}\r\n\r\n.content-console-list-item {\r\n  width: 100%;\r\n  padding: 16px;\r\n  border: 1px solid var(--console-border);\r\n  border-radius: 18px;\r\n  background: #fff;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition:\r\n    border-color 160ms ease,\r\n    box-shadow 160ms ease,\r\n    transform 160ms ease;\r\n}\r\n\r\n.content-console-list-item:hover {\r\n  border-color: #f0c5cd;\r\n  box-shadow: 0 12px 24px rgba(217, 45, 67, 0.08);\r\n}\r\n\r\n.content-console-list-item.is-active {\r\n  border-color: #ef8d9c;\r\n  background: #fff8f9;\r\n}\r\n\r\n.content-console-list-item-top {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.content-console-list-item strong {\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-list-item span,\r\n.content-console-list-item small,\r\n.content-console-user-list-login,\r\n.content-console-user-list-meta small {\r\n  color: var(--console-text-soft);\r\n}\r\n\r\n.content-console-status-badge {\r\n  padding: 6px 10px;\r\n  border-radius: 999px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  background: var(--console-warning-soft);\r\n  color: #8a5c00;\r\n  white-space: nowrap;\r\n}\r\n\r\n.content-console-status-badge.is-published {\r\n  background: var(--console-success-soft);\r\n  color: var(--console-success);\r\n}\r\n\r\n.content-console-status-badge.is-draft {\r\n  background: var(--console-danger-soft);\r\n  color: var(--console-accent-strong);\r\n}\r\n\r\n.content-console-user-list-meta {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.content-console-section-card {\r\n  padding: 20px;\r\n  border-radius: 22px;\r\n}\r\n\r\n.content-console-section-card.is-sidebar-card,\r\n.content-console-section-card.is-compact {\r\n  padding: 18px;\r\n}\r\n\r\n.content-console-section-head {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.content-console-section-head.is-inline-head {\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.content-console-section-head h3 {\r\n  margin: 0;\r\n  font-size: 17px;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-section-head p,\r\n.content-console-inline-help {\r\n  color: var(--console-text-soft);\r\n  line-height: 1.75;\r\n}\r\n\r\n.content-console-form-grid {\r\n  display: grid;\r\n  gap: 16px;\r\n}\r\n\r\n.content-console-form-grid.is-common,\r\n.content-console-form-grid.is-two-column {\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n}\r\n\r\n.content-console-form-grid.is-single-column,\r\n.content-console-form-grid.is-single-column-grid,\r\n.content-console-form-grid.is-full,\r\n.content-console-permission-grid.is-single-column-grid {\r\n  grid-template-columns: minmax(0, 1fr);\r\n}\r\n\r\n.content-console-page label {\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.content-console-page label > span:first-child,\r\n.content-console-checkbox > span,\r\n.content-console-inline-check span strong,\r\n.content-console-inline-check span small {\r\n  min-width: 0;\r\n}\r\n\r\n.content-console-page label > span:first-child {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-checkbox-row,\r\n.content-console-inline-check {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.content-console-checkbox-row {\r\n  display: grid;\r\n  grid-template-columns: 18px minmax(0, 1fr);\r\n  align-items: center;\r\n  column-gap: 10px;\r\n  min-height: 24px;\r\n  width: 100%;\r\n}\r\n\r\n.content-console-checkbox-row input {\r\n  margin: 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.content-console-checkbox-row span {\r\n  display: block;\r\n  min-width: 0;\r\n  line-height: 1.5;\r\n}\r\n\r\n.content-console-inline-check {\r\n  padding: 12px 14px;\r\n  border: 1px solid var(--console-border);\r\n  border-radius: 14px;\r\n  background: var(--console-surface-muted);\r\n}\r\n\r\n.content-console-inline-check.is-card-check {\r\n  display: grid;\r\n  grid-template-columns: 18px minmax(0, 1fr);\r\n  align-items: start;\r\n  column-gap: 12px;\r\n  row-gap: 0;\r\n}\r\n\r\n.content-console-inline-check input {\r\n  margin: 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.content-console-inline-check.is-card-check input {\r\n  margin: 3px 0 0;\r\n  justify-self: start;\r\n}\r\n\r\n.content-console-inline-check span {\r\n  display: block;\r\n  color: var(--console-text-soft);\r\n  line-height: 1.45;\r\n}\r\n\r\n.content-console-inline-check.is-card-check span {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n}\r\n\r\n.content-console-inline-check strong {\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-inline-check small {\r\n  line-height: 1.45;\r\n}\r\n\r\n.content-console-check-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.content-console-check-grid.is-stacked {\r\n  grid-template-columns: minmax(0, 1fr);\r\n}\r\n\r\n.content-console-cover-panel {\r\n  display: grid;\r\n  grid-template-columns: minmax(220px, 320px) minmax(0, 1fr);\r\n  gap: 20px;\r\n  align-items: start;\r\n}\r\n\r\n.content-console-cover-preview {\r\n  aspect-ratio: 4 / 3;\r\n  border: 1px dashed var(--console-border-strong);\r\n  border-radius: 18px;\r\n  background: var(--console-surface-muted);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  color: var(--console-text-faint);\r\n}\r\n\r\n.content-console-cover-preview img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.content-console-cover-actions {\r\n  align-items: flex-start;\r\n}\r\n\r\n.content-console-locale-card,\r\n.content-console-note-card {\r\n  padding: 16px;\r\n  border-radius: 18px;\r\n}\r\n\r\n.content-console-locale-note {\r\n  margin-top: 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.content-console-meta-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.content-console-meta-list div {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 1px solid #ebf0f5;\r\n}\r\n\r\n.content-console-meta-list div:last-child {\r\n  padding-bottom: 0;\r\n  border-bottom: 0;\r\n}\r\n\r\n.content-console-meta-list dt {\r\n  color: var(--console-text-faint);\r\n}\r\n\r\n.content-console-meta-list dd {\r\n  margin: 0;\r\n  color: var(--console-text);\r\n  font-weight: 700;\r\n  text-align: right;\r\n}\r\n\r\n.content-console-permission-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n}\r\n\r\n.content-console-permission-chip {\r\n  padding: 14px;\r\n  border: 1px solid var(--console-border);\r\n  border-radius: 16px;\r\n  background: var(--console-surface-muted);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.content-console-permission-chip strong {\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-permission-chip span {\r\n  color: var(--console-text-soft);\r\n}\r\n\r\n.content-console-permission-chip.is-enabled {\r\n  border-color: #efc4cc;\r\n  background: #fff7f8;\r\n}\r\n\r\n.content-console-user-management-view .content-console-sidebar.is-inner-sidebar {\r\n  padding: 0;\r\n  background: transparent;\r\n  border: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.content-console-user-directory.content-console-sidebar.is-inner-sidebar {\r\n  padding: 0;\r\n  background: transparent;\r\n  border: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.content-console-user-management-view .content-console-list-panel-head,\r\n.content-console-user-management-view .content-console-list,\r\n.content-console-user-management-view .content-console-pagination {\r\n  padding: 20px;\r\n  border-radius: 22px;\r\n  background: var(--console-surface);\r\n  border: 1px solid var(--console-border);\r\n  box-shadow: var(--console-shadow-soft);\r\n}\r\n\r\n.content-console-user-management-view .content-console-list {\r\n  padding: 16px;\r\n}\r\n\r\n.content-console-pagination {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.content-console-pagination-pages {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n\r\n.content-console-pagination-arrow,\r\n.content-console-pagination-page {\r\n  min-width: 42px;\r\n  height: 42px;\r\n  border: 1px solid var(--console-border-strong);\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  color: var(--console-text);\r\n  cursor: pointer;\r\n  font: inherit;\r\n}\r\n\r\n.content-console-pagination-page.is-active {\r\n  border-color: var(--console-accent);\r\n  background: var(--console-accent);\r\n  color: #fff;\r\n}\r\n\r\n.content-console-pagination-arrow:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.content-console-pagination-gap {\r\n  color: var(--console-text-faint);\r\n}\r\n\r\n.content-console-login-shell {\r\n  min-height: 100dvh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 32px 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.content-console-login-card {\r\n  width: min(480px, 100%);\r\n  padding: 28px;\r\n  border-radius: 28px;\r\n  background: var(--console-surface);\r\n  border: 1px solid var(--console-border);\r\n  box-shadow: var(--console-shadow);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n}\r\n\r\n.content-console-brand-block {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.content-console-brand-block h1 {\r\n  margin: 8px 0 0;\r\n  font-size: 28px;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-brand-block p {\r\n  margin-top: 12px;\r\n  color: var(--console-text-soft);\r\n  line-height: 1.75;\r\n}\r\n\r\n@media (max-width: 1279px) {\r\n  .content-console-main-shell {\r\n    padding: 24px;\r\n  }\r\n\r\n  .content-console-layout,\r\n  .content-console-account-shell,\r\n  .content-console-user-management-shell-body,\r\n  .content-console-editor-shell,\r\n  .content-console-editor-shell.is-account-editor-shell,\r\n  .content-console-cover-panel {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .content-console-page-header,\r\n  .content-console-list-panel-head,\r\n  .content-console-panel-head,\r\n  .content-console-toolbar-cluster,\r\n  .content-console-user-editor-stage-head {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .content-console-page-header-meta,\r\n  .content-console-summary-grid.is-three-column,\r\n  .content-console-permission-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n}\r\n\r\n@media (max-width: 1023px) {\r\n  body.content-console-body {\r\n    overflow: hidden;\r\n  }\r\n\r\n  .content-console-mobile-toggle {\r\n    position: fixed;\r\n    top: 18px;\r\n    left: 18px;\r\n    z-index: 55;\r\n    display: inline-flex;\r\n    width: auto;\r\n    padding: 0 14px;\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .content-console-sidebar-icon-button.is-desktop-only {\r\n    display: none;\r\n  }\r\n\r\n  .content-console-sidebar-icon-button.is-mobile-only {\r\n    display: inline-flex;\r\n  }\r\n\r\n  .content-console-app-sidebar {\r\n    width: min(320px, calc(100vw - 32px));\r\n    transform: translateX(-100%);\r\n    box-shadow: var(--console-shadow);\r\n  }\r\n\r\n  .content-console-page.has-mobile-sidebar-open .content-console-app-sidebar {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  .content-console-main-shell,\r\n  .content-console-page.is-sidebar-collapsed .content-console-main-shell {\r\n    inset: 0;\r\n    padding: 76px 18px 18px;\r\n  }\r\n\r\n  .content-console-mobile-backdrop {\r\n    position: absolute;\r\n    inset: 0;\r\n    display: block;\r\n    background: rgba(15, 23, 42, 0.22);\r\n    border: 0;\r\n    z-index: 35;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .content-console-page-header-meta,\r\n  .content-console-summary-grid.is-three-column,\r\n  .content-console-form-grid.is-common,\r\n  .content-console-form-grid.is-two-column,\r\n  .content-console-check-grid,\r\n  .content-console-permission-grid {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .content-console-tabs,\r\n  .content-console-management-tabs,\r\n  .content-console-locale-tabs,\r\n  .content-console-editor-actions,\r\n  .content-console-action-row,\r\n  .content-console-cover-actions,\r\n  .content-console-user-editor-stage-head {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .content-console-tabs button,\r\n  .content-console-locale-tabs button,\r\n  .content-console-primary-button,\r\n  .content-console-secondary-button,\r\n  .content-console-danger-button {\r\n    width: 100%;\r\n  }\r\n\r\n  .content-console-mobile-only-action {\r\n    display: inline-flex;\r\n  }\r\n\r\n  .content-console-management-tabs {\r\n    display: flex;\r\n    align-self: stretch;\r\n  }\r\n\r\n  .content-console-user-directory.is-mobile-hidden,\r\n  .content-console-user-editor-stage.is-mobile-hidden {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .content-console-page-header-copy h2 {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .content-console-sidebar,\r\n  .content-console-editor,\r\n  .content-console-section-card,\r\n  .content-console-user-management-view .content-console-list-panel-head,\r\n  .content-console-user-management-view .content-console-list,\r\n  .content-console-user-management-view .content-console-pagination {\r\n    border-radius: 18px;\r\n  }\r\n\r\n  .content-console-list-item-top,\r\n  .content-console-user-list-meta,\r\n  .content-console-meta-list div,\r\n  .content-console-pagination,\r\n  .content-console-list-summary {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .content-console-list-summary > span:last-child {\r\n    text-align: left;\r\n  }\r\n\r\n  .content-console-pagination-pages {\r\n    justify-content: flex-start;\r\n  }\r\n}\r\n\r\n.content-console-summary-grid.is-four-column {\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n}\r\n\r\n.content-console-summary-grid.is-five-column {\r\n  grid-template-columns: repeat(5, minmax(0, 1fr));\r\n}\r\n\r\n.content-console-tight-grid {\r\n  margin-top: 16px;\r\n}\r\n\r\n.content-console-cover-preview.is-qr-preview {\r\n  aspect-ratio: 1 / 1;\r\n  max-width: 280px;\r\n}\r\n\r\n.content-console-cropper-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 120;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  background: rgba(15, 23, 42, 0.48);\r\n  backdrop-filter: blur(6px);\r\n}\r\n\r\n.content-console-cropper-dialog {\r\n  width: min(920px, 100%);\r\n  max-height: calc(100dvh - 48px);\r\n  overflow: auto;\r\n  padding: 24px;\r\n  border-radius: 28px;\r\n  background: var(--console-surface);\r\n  border: 1px solid var(--console-border);\r\n  box-shadow: var(--console-shadow);\r\n  display: grid;\r\n  gap: 20px;\r\n}\r\n\r\n.content-console-cropper-head,\r\n.content-console-cropper-controls,\r\n.content-console-cropper-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n}\r\n\r\n.content-console-cropper-head h3 {\r\n  margin: 0;\r\n  font-size: 22px;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-cropper-head p {\r\n  margin: 8px 0 0;\r\n  color: var(--console-text-soft);\r\n  line-height: 1.7;\r\n}\r\n\r\n.content-console-cropper-stage {\r\n  padding: 24px;\r\n  border-radius: 22px;\r\n  background:\r\n    linear-gradient(135deg, rgba(217, 45, 67, 0.08), rgba(19, 34, 56, 0.06)),\r\n    var(--console-surface-muted);\r\n  border: 1px solid var(--console-border);\r\n  overflow: auto;\r\n}\r\n\r\n.content-console-cropper-viewport {\r\n  position: relative;\r\n  margin: 0 auto;\r\n  border-radius: 24px;\r\n  overflow: hidden;\r\n  background:\r\n    linear-gradient(45deg, #eef2f7 25%, transparent 25%),\r\n    linear-gradient(-45deg, #eef2f7 25%, transparent 25%),\r\n    linear-gradient(45deg, transparent 75%, #eef2f7 75%),\r\n    linear-gradient(-45deg, transparent 75%, #eef2f7 75%);\r\n  background-size: 24px 24px;\r\n  background-position: 0 0, 0 12px, 12px -12px, -12px 0;\r\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55);\r\n  touch-action: none;\r\n  cursor: grab;\r\n  user-select: none;\r\n}\r\n\r\n.content-console-cropper-viewport.is-dragging {\r\n  cursor: grabbing;\r\n}\r\n\r\n.content-console-cropper-viewport::after {\r\n  content: '';\r\n  position: absolute;\r\n  inset: 0;\r\n  border: 2px solid rgba(255, 255, 255, 0.92);\r\n  border-radius: inherit;\r\n  box-shadow: inset 0 0 0 9999px rgba(15, 23, 42, 0.12);\r\n  pointer-events: none;\r\n}\r\n\r\n.content-console-cropper-viewport img {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  max-width: none;\r\n  max-height: none;\r\n  pointer-events: none;\r\n}\r\n\r\n.content-console-cropper-zoom {\r\n  flex: 1 1 260px;\r\n  display: grid;\r\n  gap: 8px;\r\n}\r\n\r\n.content-console-cropper-zoom span {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-cropper-zoom input[type=range] {\r\n  width: 100%;\r\n  padding: 0;\r\n  border: 0;\r\n  box-shadow: none;\r\n  background: transparent;\r\n}\r\n\r\n.content-console-requirement-stack {\r\n  display: grid;\r\n  gap: 18px;\r\n}\r\n\r\n.content-console-requirement-card {\r\n  padding: 18px;\r\n  border-radius: 18px;\r\n  border: 1px solid var(--console-border);\r\n  background: var(--console-surface-muted);\r\n  display: grid;\r\n  gap: 16px;\r\n}\r\n\r\n.content-console-requirement-card-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.content-console-requirement-card-head strong {\r\n  font-size: 16px;\r\n  color: var(--console-text);\r\n}\r\n\r\n.content-console-span-two {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.content-console-requirement-placeholder {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 1279px) {\r\n  .content-console-summary-grid.is-four-column {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n\r\n  .content-console-summary-grid.is-five-column {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .content-console-summary-grid.is-four-column {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .content-console-summary-grid.is-five-column {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .content-console-requirement-card-head {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .content-console-cropper-overlay {\r\n    padding: 16px;\r\n  }\r\n\r\n  .content-console-cropper-dialog {\r\n    padding: 18px;\r\n    border-radius: 20px;\r\n  }\r\n\r\n  .content-console-cropper-head,\r\n  .content-console-cropper-controls,\r\n  .content-console-cropper-actions {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .content-console-cropper-stage {\r\n    padding: 12px;\r\n  }\r\n}\r\n\r\n.content-console-account-shell.is-self-only {\r\n  grid-template-columns: minmax(0, 1fr);\r\n}\r\n\r\n.content-console-account-shell.is-self-only .content-console-self-management-shell {\r\n  width: 100%;\r\n}\r\n\r\n.content-console-permission-chip small {\r\n  color: var(--console-text-faint);\r\n  line-height: 1.45;\r\n}\r\n\r\n.content-console-sidebar .content-console-locale-tabs {\r\n  width: 100%;\r\n}\r\n\r\n.content-console-sidebar .content-console-locale-tabs button {\r\n  flex: 1 1 0;\r\n}\r\n\r\n\r\n.content-console-analytics-shell {\r\n  display: grid;\r\n  gap: 24px;\r\n}\r\n\r\n.analytics-hero-card,\r\n.analytics-chart-card {\r\n  overflow: hidden;\r\n}\r\n\r\n.analytics-hero-head {\r\n  align-items: flex-start;\r\n}\r\n\r\n.analytics-summary-grid {\r\n  margin-top: 18px;\r\n}\r\n\r\n.analytics-chart-grid,\r\n.analytics-ranking-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 24px;\r\n}\r\n\r\n.analytics-chart-meta {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.analytics-chart-meta div,\r\n.analytics-ranking-item {\r\n  padding: 14px 16px;\r\n  border: 1px solid var(--console-border);\r\n  border-radius: 16px;\r\n  background: var(--console-surface-muted);\r\n}\r\n\r\n.analytics-chart-meta span,\r\n.analytics-ranking-item span {\r\n  display: block;\r\n  color: var(--console-text-soft);\r\n}\r\n\r\n.analytics-chart-meta strong,\r\n.analytics-ranking-item strong {\r\n  color: var(--console-text);\r\n}\r\n\r\n.analytics-line-chart-shell {\r\n  height: 240px;\r\n  border-radius: 20px;\r\n  border: 1px solid var(--console-border);\r\n  background:\r\n    linear-gradient(to bottom, rgba(217, 45, 67, 0.04), rgba(255, 255, 255, 0.9)),\r\n    repeating-linear-gradient(to top, transparent, transparent 47px, rgba(19, 34, 56, 0.06) 48px);\r\n  padding: 16px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.analytics-line-chart {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: visible;\r\n}\r\n\r\n.analytics-chart-labels {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-top: 12px;\r\n  color: var(--console-text-faint);\r\n  font-size: 13px;\r\n}\r\n\r\n.analytics-ranking-list {\r\n  display: grid;\r\n  gap: 12px;\r\n}\r\n\r\n.analytics-ranking-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n}\r\n\r\n.analytics-ranking-metrics {\r\n  text-align: right;\r\n}\r\n\r\n@media (max-width: 1279px) {\r\n  .analytics-chart-grid,\r\n  .analytics-ranking-grid {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .analytics-chart-meta,\r\n  .analytics-ranking-item {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .analytics-ranking-item {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .analytics-ranking-metrics {\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
